import React, { useEffect } from "react"

import { MetaData } from "@shared/components"
import { LayerPopupProvider, MessageSenderProvider } from "@shared/contexts"
import { ChatProvider } from "@shared/contexts"
import { ScheduleProvider } from "@shared/contexts"
import { useCriteo, useCRM } from "@shared/hooks"

import { ChatMode } from "chatMode/components"

function ChatModePage() {
  useCriteo()
  useCRM()

  useEffect(() => {
    const preventDefault = (e: Event) => {
      e.preventDefault()
    }

    const keyEvent = (e: KeyboardEvent) => {
      if (
        ((e.ctrlKey || e.metaKey) && (e.keyCode === 78 || e.keyCode === 82)) ||
        e.keyCode === 116
      ) {
        e.cancelBubble = true
        e.returnValue = false
        return
      }
    }

    window.document.addEventListener("keydown", keyEvent)
    document.addEventListener("contextmenu", preventDefault)

    return () => {
      window.document.removeEventListener("keydown", keyEvent)
      document.removeEventListener("contextmenu", preventDefault)
    }
  }, [])

  return (
    <LayerPopupProvider>
      <ChatProvider>
        <MessageSenderProvider>
          <MetaData />
          <ChatMode />
        </MessageSenderProvider>
      </ChatProvider>
    </LayerPopupProvider>
  )
}

export default () => (
  <ScheduleProvider isDetect={false}>
    <ChatModePage />
  </ScheduleProvider>
)
